import { render, staticRenderFns } from "./symptomList.vue?vue&type=template&id=2736a024&scoped=true"
import script from "./symptomList.vue?vue&type=script&lang=js"
export * from "./symptomList.vue?vue&type=script&lang=js"
import style0 from "./symptomList.vue?vue&type=style&index=0&id=2736a024&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2736a024",
  null
  
)

export default component.exports